import React, { useState, useEffect } from "react";
import { Box, Container, Typography, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        backgroundImage: `url('bg2.svg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          py: { xs: 4, md: 6 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexDirection: { xs: "column-reverse", lg: "row" },
          gap: { xs: 0, lg: 2 },
        }}
      >
        <Box
          sx={{
            width: { xs: "90%", lg: "50%" },
            height: "100%",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            textAlign: "left",
            mt: { xs: 1, md: 2 },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "2rem", md: "3rem" },
              fontWeight: 600,
              lineHeight: 1.2,
              mb: { xs: 1, md: 2 },
              maxWidth: { xs: "100%", lg: "80%" },
            }}
          >
            Generate <span style={{ color: "rgb(0, 208, 132)" }}>WhatsApp</span>{" "}
            Chat button & widget
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "1rem", md: "1.25rem" },
              color: "text.secondary",
              lineHeight: 1.5,
              mb: { xs: 1, md: 2 },
              maxWidth: { xs: "100%", lg: "80%" },
            }}
          >
            Give users the opportunity to contact you on WhatsApp, ensuring the
            fastest and most convenient interaction for your website visitors.
          </Typography>
          <Button
            sx={{
              px: 4,
              py: 1,
              borderRadius: "10px",
              alignItems: "flex-start",
              color: "#fff",
              width: "fit-content",
              bgcolor: "rgb(5, 78, 146)",
              "&:hover": {
                bgcolor: "rgb(44, 108, 168)",
              },
              alignSelf: "flex-start",
              textTransform: "capitalize",
              fontWeight: 600,
              fontSize: { xs: "16px", lg: "18px" },
            }}
            onClick={() => navigate("/whatsapp-button/widget")}
          >
            Create Now
          </Button>
        </Box>
        <Box
          sx={{
            px: { xs: 4, lg: 2 },
            width: { xs: "100%", lg: "50%" },
            height: { xs: "70%", lg: "100%" },
          }}
        >
          <img
            src="https://gs-upload.gupshup.io/revamp/assets/v3/images/whatsapp-widget/hero-img.png"
            alt="img"
            width={"100%"}
            height={"100%"}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;
